import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.img`
  ${({ displayState }) => css`
    display: ${displayState.hidden ? 'none' : ''};
    border-radius: 50%;
    object-fit: cover;
    width: 84px;
    height: 84px;

    @media only screen and (min-width: 768px) {
      width:  ${displayState.size === 'big' ? '142px' : displayState.size === 'big' ? '84px' : displayState.size === 'vSmall' ? '26px' : '108px'};
      height:  ${displayState.size === 'big' ? '142px' : displayState.size === 'big' ? '84px' : displayState.size === 'vSmall' ? '26px' : '108px'};
    }
  `}
`;

export default Atom({ type: 'image', dataType: 'string', template })